export default __webpack_public_path__ + "static/media/design_helper_drawer_image.42bab6fd.png";